import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=51283e42&scoped=true&lang=pug&"
import script from "./Bookmarks.vue?vue&type=script&lang=ts&"
export * from "./Bookmarks.vue?vue&type=script&lang=ts&"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=51283e42&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51283e42",
  null
  
)

export default component.exports